<template>
	<v-app>
		<v-main class="grey lighten-3">
			<div class="background-image"></div>
			<v-container fill-height>
				<v-row justify="center" align="center">
					<v-col cols="12" sm="8" md="6" lg="4">
						<v-card class="elevation-12">
							<!-- 标题 -->
							<v-toolbar color="primary" dark flat>
								<v-toolbar-title>惠州科特海鸥供应商系统</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-icon large>mdi-account-key</v-icon>
							</v-toolbar>

							<!-- 表单内容 -->
							<v-card-text>
								<v-form ref="form" @submit.prevent="login">
									<!-- 用户名 -->
									<v-text-field v-model="username" label="用户名" prepend-icon="mdi-account"
										:rules="usernameRules" clearable required></v-text-field>

									<!-- 密码 -->
									<v-text-field v-model="password" label="密码" prepend-icon="mdi-lock"
										:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
										:type="showPassword ? 'text' : 'password'"
										@click:append="showPassword = !showPassword" :rules="passwordRules"
										required></v-text-field>

									<!-- 记住我 -->
									<v-checkbox v-model="rememberMe" label="记住登录状态" color="primary" hide-details
										class="mt-0"></v-checkbox>

								<!-- 按钮组 -->
									<v-btn type="submit" color="primary" block large class="mt-4"
										:loading="loading">登录</v-btn>

									<!-- 微信登录（仅移动端微信显示；电脑版微信不支持网页授权） -->
									<v-btn v-if="isWechatMobile" color="success" block large class="mt-2"
										:loading="loading" @click="wechatLogin">微信一键登录</v-btn>
								</v-form>

								<!-- 微信电脑版提示（不支持网页授权） -->
								<v-alert v-if="isWechatDesktop" dense text type="info" class="mt-4 mb-0 text-caption">
									微信电脑版不支持网页授权登录，请使用账号密码登录；或用手机微信打开本页面自动登录。
								</v-alert>
							</v-card-text>

							<!-- 错误提示 -->
							<v-slide-y-transition>
								<v-alert v-if="errorMessage" dense outlined type="error" class="ma-4">
									{{ errorMessage }}
								</v-alert>
							</v-slide-y-transition>

							<!-- 底部链接 -->
							<v-card-actions class="justify-center grey lighten-4">
								<v-btn text small color="secondary" to="/resetPw">忘记密码?</v-btn>
								<v-divider vertical></v-divider>
								<v-btn text small color="secondary" to="/register">立即注册</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
	const _ua = navigator.userAgent.toLowerCase();
	const _isWechat = _ua.includes('micromessenger');
	const _isWechatDesktop = _isWechat && (_ua.includes('windowswechat') || _ua.includes('macwechat')
		|| _ua.includes('windows nt') || _ua.includes('macintosh'));

	export default {
		data: () => ({
			username: localStorage.getItem('savedUsername') || '',
			password: '',
			showPassword: false,
			rememberMe: false,
			loading: false,
			errorMessage: '',
			isWechatMobile: _isWechat && !_isWechatDesktop,
			isWechatDesktop: _isWechatDesktop,
			usernameRules: [
				v => !!v || '用户名不能为空',
				v => v.length >= 4 || '用户名至少4个字符'
			],
			passwordRules: [
				v => !!v || '密码不能为空',
				v => v.length >= 6 || '密码至少6个字符'
			]
		}),

		created() {
			//微信授权回调错误提示
			const wxError = this.$route.query.wxError;
			if (wxError == '3') {
				this.errorMessage = '该微信未绑定账号，请先用账号密码登录，然后在个人中心绑定微信';
			} else if (wxError == '2') {
				this.errorMessage = '微信授权失败，请重试';
			} else if (wxError == '1') {
				this.errorMessage = '微信登录失败，请重试';
			}
		},

		methods: {
			wechatLogin() {
				//跳转微信授权（后端自动重定向到微信授权页）
				window.location.href = '/kt-supplier/wechat/loginUrl';
			},
			async login() {
				if (!this.$refs.form.validate()) return

				this.loading = true
				this.errorMessage = ''

				try {
					// 模拟API调用
					const response = await this.$axios.post('/kt-supplier/login', {
						user: {
							loginName: this.username,
							password: this.password
						}
					})

					if (response.data.state == 200) {
						// 记住用户名
						if (this.rememberMe) {
							localStorage.setItem('savedUsername', this.username)
						} else {
							localStorage.removeItem('savedUsername')
						}
						// 存储Token并跳转
						localStorage.setItem('authToken', response.data.data[0].token);
						localStorage.setItem('venderId', response.data.data[0].venderIdString);
						localStorage.setItem('menu', JSON.stringify(response.data.data[1]));
						this.$router.push('/')
					}
					if (response.data.state == 500) {
						this.errorMessage = response.data.msg;
					}
				} catch (error) {
					this.handleError(error)
					this.errorMessage = "登录失败"
				} finally {
					this.loading = false
				}
			},
			forgot() {
				this.errorMessage = "可联系我们的采购重置密码";
			},
			handleError(error) {
				if (error.response) {
					switch (error.response.status) {
						case 401:
							this.errorMessage = '用户名或密码错误'
							break
						case 500:
							this.errorMessage = '服务器内部错误'
							break
						default:
							this.errorMessage = `请求失败 (${error.response.status})`
					}
				} else {
					this.errorMessage = '网络连接失败，请检查网络设置'
				}
			}
		}
	}
</script>

<style scoped>
	.v-card {
		border-radius: 8px;
		overflow: hidden;
	}

	.v-text-field {
		margin-bottom: 16px;
	}

	.v-btn--loading::before {
		opacity: 0.3;
	}

	.background-image {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: left;
		pointer-events: none;
		background-image: url(./../assets/seagull-bg.png);
		background-color: #00599b;
		opacity: 0.6
	}
</style>